import { render, staticRenderFns } from "./OnboardApplyList.vue?vue&type=template&id=58bed470&"
import script from "./OnboardApplyList.vue?vue&type=script&lang=js&"
export * from "./OnboardApplyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports